import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationCircle } from '@fortawesome/pro-solid-svg-icons/faExclamationCircle';
import React from 'react';
import PropTypes from 'prop-types';
import { Tooltip } from 'ui-components/components/tooltip';
import { TooltipContent } from 'ui-components/components/tooltip/tooltip-content';
import { TooltipService } from 'ui-components/services/tooltip-service';
import style from './style.module.css';
import { emptyArray } from 'ui-components/default-props/empty';

const mapMessagesToList = (errors, shouldStyleItems) => {
  const styleName = shouldStyleItems ? 'styled-error-item' : 'unstyled-error-item';
  return (
    <React.Fragment>
      {errors.map((msg, index) => {
        return (
          <li key={`${index}-${msg}`} className={style[styleName]}>
            {msg}
          </li>
        );
      })}
    </React.Fragment>
  );
};

const calculateErrorMessage = (messages = emptyArray) => {
  const plural = messages.length > 1;
  return plural ? `${messages.length} Errors` : `${messages.length} Error`;
};

const renderContent = (errors, layout) => (
  <div className={style[`${layout}`]}>
    <FontAwesomeIcon className={style['exclamation-triangle-solid']} icon={faExclamationCircle} />
    {layout !== 'icon-only' && <span className={style['error-message-text']}>{calculateErrorMessage(errors)}</span>}
  </div>
);

const renderErrorsWrapper = (errors, layout, position) => (
  <Tooltip position={position}>
    <TooltipContent>
      <div className={style['tooltip-content']}>{mapMessagesToList(errors)}</div>
    </TooltipContent>
    {renderContent(errors, layout)}
  </Tooltip>
);

export const ErrorBadgeWithTooltip = ({
  errors = emptyArray,
  layout = 'text-with-background',
  position = 'bottom',
  shouldStyleItems = false,
}) => {
  if (errors.length < 1) {
    return null;
  }

  return renderErrorsWrapper(errors, layout, position, shouldStyleItems);
};

ErrorBadgeWithTooltip.propTypes = {
  errors: PropTypes.arrayOf(PropTypes.string),
  layout: PropTypes.oneOf(['icon-only', 'text', 'text-with-background']),
  position: PropTypes.oneOf(TooltipService.getValidPositions()),
  shouldStyleItems: PropTypes.bool,
};
